import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
@NgModule({
  imports: [CommonModule],
  exports: [],
  providers: [],
  declarations: [
  ],
})
export class SvcsCoreBusinessModule { }
